// extracted by mini-css-extract-plugin
export const root = "gallery-item-module--root--w2J8y";